import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetIndexnowStatusV1Response } from './get-indexnow-status-v1-response';
import { getIndexnowStatusV1ResponseSchema } from './get-indexnow-status-v1-response';

export async function getIndexnowStatusV1Api(): Promise<
  IValidatedResponse<IGetIndexnowStatusV1Response>
> {
  return getRequest<IGetIndexnowStatusV1Response>({
    path: '/sys/indexnow/v1/status',
    schema: getIndexnowStatusV1ResponseSchema,
  });
}
